<template>
    <div class="tinymce-editor">
      <editor id="tinyeditor" v-model="content" :init="init" :disables="disabled"></editor>
  </div>
</template>

<script>
import serverPath from '../assets/js/serverPath.js'
import Editor from '@tinymce/tinymce-vue'
import tinymce from "tinymce/tinymce.js";
import "tinymce/icons/default/icons";

import 'tinymce/themes/silver/theme'
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image/plugin";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/pagebreak";
import 'tinymce/plugins/help'
import "tinymce/plugins/anchor";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/preview";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/advlist";
import "tinymce/plugins/codesample";
import "tinymce/plugins/hr";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/template";
import "tinymce/plugins/charmap";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
// import "tinymce/plugins/bdmap";
import axios from 'axios'
export default {
    
    components:{
	    Editor
  	},
    props: {
      value: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plugins: {
        type: [String, Array],
        default:
          "preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr nonbreaking insertdatetime advlist lists wordcount imagetools textpattern autosave autoresize"
      },
      toolbar: {
        type: [String, Array],
        default:
          "code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link codesample | alignleft aligncenter alignright alignjustify outdent indent formatpainter | \
      styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
      table image media charmap hr pagebreak insertdatetime | fullscreen preview"
      }
    },
    data() {
    return {
      content:'',
      //初始化配置
      init: {
        selector:'#tinyeditor',
        language_url: '../../static/tinymce/langs/zh_CN.js', // vue-cli2.x
        skin_url: "../../static/tinymce/skins/ui/oxide",
        language:'zh_CN',
        plugins: 'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave bdmap indent2em autoresize formatpainter axupimgs',
        toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
        styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
        table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs',
        height: 770, //编辑器高度
        min_height: 770,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
        link_list: [
            
        ],
        image_list: [
            
        ],
        image_class_list: [
        { title: 'None', value: '' },
        { title: 'Some class', value: 'class-name' }
        ],
        importcss_append: true,
        // 文件类型
        file_picker_types:'file image media',
        //自定义文件选择器的回调内容
        
        images_upload_handler: function (blobInfo, succFun, failFun) {
        
            var file = blobInfo.blob();//转化为易于理解的file对象
            let objUrl = file;
            let formData = new FormData();
            formData.append('file', objUrl);
            formData.append('uid', localStorage.getItem('uid'));
            axios({
              method: 'post',
              url: serverPath.serverPath+'/api/v2/file/upload',
              data: formData,
            }).then((res)=>{
              console.log(res)
              succFun(res.data.data.path)
            })
    
        },
        file_picker_callback:function(callback,value,meta){
            var filetype = ".pdf,.txt,.doc,.docx,.xls,.xlsx,.mp3,.mp4";
            var upurl = serverPath.serverPath+'/api/v2/file/upload'
            console.log(value)
            if(meta.filetype == 'file'){
                var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', filetype);
                input.click();
                input.onchange = function() {
                  var file = this.files[0];
                  let objUrl = file;
                  let formData = new FormData();
                  formData.append('file', objUrl);
                  formData.append('uid', localStorage.getItem('uid'));
                  axios({
                    method: 'post',
                    url: serverPath.serverPath+'/api/v2/file/upload',
                    data: formData,
                  }).then((res)=>{
                    console.log(res)
                    callback(res.data.data.path)
                  })
                  }
                  
            }
            if(meta.filetype == 'media'){
                var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', filetype);
                input.click();
                input.onchange = function() {
                  var file = this.files[0];
                  let objUrl = file;
                  let formData = new FormData();
                  formData.append('file', objUrl);
                  formData.append('uid', localStorage.getItem('uid'));
                  axios({
                    method: 'post',
                    url: serverPath.serverPath+'/api/v2/file/upload',
                    data: formData,
                  }).then((res)=>{
                    console.log(res)
                    callback(res.data.data.path)
                  })
                  }
                  
            }
            
        },

        toolbar_sticky: true,
        toolbar_mode: "wrap",
        autosave_ask_before_unload: false,
      },
      content: this.value
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    
  },
  watch: {
    value(newValue) {
      this.content = newValue;
    },
    content(newValue) {
      this.$emit("input", newValue);
    }
  }
};

</script>

<style  scoped>

</style>


// WEBPACK FOOTER //
// src/components/tinymce.vue